<disclaimer *ngIf="isViewMode" [message]="'LOCATION_ENVIRONMENT_DIALOG.DISCLAIMER.NO_EDIT' | translate"> </disclaimer>
<disclaimer *ngIf="!isViewMode" [message]="'LOCATION_ENVIRONMENT_DIALOG.DISCLAIMER.HELP' | translate"></disclaimer>

<fc-outlined-input
  [label]="'LOCATION_ENVIRONMENT_DIALOG.CONTROL.NAME' | translate"
  [control]="locationEnvironmentForm.controls.name"
  [required]="true"
  [maxLength]="100"
>
  <ng-container *ngIf="locationEnvironmentForm.controls.name.hasError('required')">
    {{ 'LOCATION_ENVIRONMENT_DIALOG.CONTROL.ERRORS.NAME.REQUIRED' | translate }}
  </ng-container>
  <ng-container *ngIf="locationEnvironmentForm.controls.name.hasError('maxlength')">
    {{ 'LOCATION_ENVIRONMENT_DIALOG.CONTROL.ERRORS.NAME.MAX_LENGTH' | translate }}
  </ng-container>
  <ng-container *ngIf="locationEnvironmentForm.controls.name.hasError('nameAlreadyExists')">
    {{ 'LOCATION_ENVIRONMENT_DIALOG.CONTROL.ERRORS.NAME.DUPLICATED' | translate }}
  </ng-container>
</fc-outlined-input>

<fc-location-input
  [control]="locationEnvironmentForm.controls.location"
  [requiredMark]="true"
  [translateErrorPrefix]="'MAINTENANCES.CREATE_DIALOG.ERRORS'"
></fc-location-input>

<div class="sector-wrapper">
  <fc-location-sector-input
    class="sector-wrapper__input"
    [control]="locationEnvironmentForm.controls.locationSector"
    [locationId]="locationEnvironmentForm.controls.location.value?.id"
    [requiredMark]="true"
    [translateErrorPrefix]="'MAINTENANCES.CREATE_DIALOG.ERRORS'"
    [preloadOptions]="true"
    [showChevronIcon]="true"
  ></fc-location-sector-input>
  <button
    class="sector-wrapper__qr-code"
    type="button"
    mat-stroked-button
    color="primary"
    (click)="locationEnvironmentForm.controls.qrCode.value ? openQrCodeDialog() : generateQrCode()"
  >
    <mat-icon>{{ locationEnvironmentForm.controls.qrCode.value ? 'visibility' : 'qr_code' }}</mat-icon>
    <span>
      {{
        (locationEnvironmentForm.controls.qrCode.value
          ? 'LOCATION_ENVIRONMENT_DIALOG.BUTTON.QR_CODE_VIEW'
          : 'LOCATION_ENVIRONMENT_DIALOG.BUTTON.QR_CODE_ADD'
        ) | translate
      }}
    </span>
  </button>
</div>

<fc-text-area-input
  class="tab-new-general__card__inputs__two-columns"
  [label]="'LOCATION_ENVIRONMENT_DIALOG.CONTROL.DESCRIPTION' | translate"
  [control]="locationEnvironmentForm.controls.description"
  [requiredMark]="false"
  [maxLength]="2000"
>
</fc-text-area-input>
